// Helpers for <input type="datetime-local"> ⇄ API (ISO-8601) conversion.
//
// A datetime-local input's value ("2026-08-05T21:00") carries NO timezone.
// Posting it raw makes the backend's `new Date(...)` cast resolve it against
// the *server's* timezone (UTC in production), so an IST admin scheduling
// "today 9 PM" ends up with a start time 5h30m later — which reads back as
// tomorrow and keeps the quiz hidden from students past its intended start.
//
// Always round-trip through these two helpers instead.

/** ISO string (or Date) → "YYYY-MM-DDTHH:mm" in the *viewer's* local timezone. */
export const toDateTimeLocal = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16);
};

/** "YYYY-MM-DDTHH:mm" (local wall-clock) → absolute ISO-8601 UTC string. */
export const fromDateTimeLocal = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

export default { toDateTimeLocal, fromDateTimeLocal };
